import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportTable from "../components/ReportTable";
import Pagination from "../components/Pagination";
import PageHeader from "../components/PageHeader";
import DateRangeFilter from "../components/DateRangeFilter";
import Loader from "../components/Loader";
import SkSelect from "../components/SkSelect";
import "../assets/css/shiftgroup.css";
import moment from "moment-timezone";
import  { formatWithTimeZone, formatTime12Hour, formatTime24 } from "../utils/common";

import {
  shiftList,
  createShift,
  getShiftById,
  updateShift,
  deleteShift,
  checkDeleteShift,
  shiftGroupListsApis,
} from "../redux/shiftgroup/ShiftGroupActions";

import {
  selectShiftData,
  selectShiftGroupStatus,
  selectShiftMeta,
  selectShiftGroupData,
} from "../redux/shiftgroup/ShiftGroupSelector";

const columns = [
  { key: "action", label: "Action", className:"sticky-action" },
  { key: "shiftNo", label: "Shift No" },
  // { key: "sno", label: "S.No" },
  { key: "shiftName", label: "Shift Name" },
  { key: "shortName", label: "Short Name" },
  
  { key: "shiftGroup", label: "Shift Group" },
  { key: "inTime", label: "In", filterType: "time"},
  { key: "outTime", label: "Out",filterType: "time" },
  {
    key: "status",
    label: "Status",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "1", label: "Active" },
      { value: "0", label: "Inactive" },
    ],
  },
];


const getTime = (time, nextDay = false) => {
  if (!time) return null;

  const [hours, minutes] = time.split(":").map(Number);

  let totalMinutes = hours * 60 + minutes;

  if (nextDay) {
    totalMinutes += 24 * 60; // Add 24 hours
  }

  return totalMinutes;
};

const toMinutes = (time) => {
  if(!time) return null;
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
}
const getMinutesDifference = (inTime, outTime) => {
  if (!inTime || !outTime) return null;

  const [inHour, inMin] = inTime.split(":").map(Number);
  const [outHour, outMin] = outTime.split(":").map(Number);

  let inMinutes = inHour * 60 + inMin;
  let outMinutes = outHour * 60 + outMin;

  // Automatically treat it as next day
  if (outMinutes <= inMinutes) {
    outMinutes += 24 * 60;
  }

  return outMinutes - inMinutes;
};

const calculateDuration = (inTime, outTime) => {
  if (!inTime || !outTime) return null;

  let start = toMinutes(inTime);
  let end = toMinutes(outTime);

  // Overnight shift
  if (end <= start) {
    end += 24 * 60;
  }

  const workingMinutes = end - start;

  return {
  WorkingMins: workingMinutes,
  WorkingHours: minutesToTime(workingMinutes),

  HalfDayWorkingMins: Math.floor(workingMinutes / 2),
  HalfDayWorkingHours: minutesToTime(
    Math.floor(workingMinutes / 2)
  ),

  // LunchBreakMins: 0,
  // LunchBreakHours: minutesToTime(0),
};
};
const minutesToTime = (minutes) => {
  if (minutes == null) return "";

  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;

  return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};
const ACTIVE_STATUS_OPTIONS = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const emptyForm = {
  ShiftCode: "",
  ShiftGroupCode: "",
  ShiftGroupName: "",
  ShiftNo: "",
  ShiftName: "",
  ShortName: "",
  BeginningIn: "",
  BeginningInNextDay: false,
  BeginningOut: "",
  BeginningOutNextDay: false,
  InTime: "",
  OutTime: "",
  EndingIn: "",
  EndingInNextDay: false,
  EndingOut: "",
  EndingOutNextDay: false,
  WorkingMins: "",
  WorkingHours: "",
  HalfDayWorkingMins: "",
  HalfDayWorkingHours: "",
  LunchBreakMins: "",
  LunchBreakHours: "",
  Status: true,
};
// Treats "", null, undefined and whitespace-only as empty.
const isBlank = (v) => v === undefined || v === null || String(v).trim() === "";

// Single source of truth for the Add/Edit Shift validation rules.
// Returns an object keyed by field name; empty object means the form is valid.
const getShiftErrors = (data, shiftData) => {
  const e = {};
  const num = (v) => Number(v);


const inTime = getTime(data.InTime);

let outTime = getTime(data.OutTime);

if (outTime != null && inTime != null && outTime <= inTime) {
  outTime += 24 * 60;
}

if (
  outTime != null &&
  data.BeginningOutNextDay &&
  outTime < 24 * 60
) {
  outTime += 24 * 60;
}
const beginningIn = getTime(
  data.BeginningIn,
  data.BeginningInNextDay
);

const beginningOut = getTime(
  data.BeginningOut,
  data.BeginningOutNextDay
);

const endingIn = getTime(
  data.EndingIn,
  data.EndingInNextDay
);

const endingOut = getTime(
  data.EndingOut,
  data.EndingOutNextDay
);
  // Shift Details
  if (isBlank(data.ShiftGroupCode)) {
    e.ShiftGroupCode = "Shift Group is required.";
  }

  const shiftName = (data.ShiftName || "").trim().toLowerCase();

if (isBlank(data.ShiftName)) {
  e.ShiftName = "Shift Name is required.";
} else if (String(data.ShiftName).trim().length > 50) {
  e.ShiftName = "Shift Name cannot exceed 50 characters.";
} else if (
  !/^[A-Za-z][A-Za-z0-9\s\-_/&()]*$/.test(data.ShiftName.trim())
) {
  e.ShiftName =
    "Shift Name can contain only letters, numbers, spaces, -, _, /, &, and ().";
}
 else{
  const isShiftNameExists = shiftData.some(
    (item) => (item.ShiftName || "").trim().toLowerCase() === shiftName && item.ShiftCode !== data.ShiftCode
  );
  if(isShiftNameExists) {
  e.ShiftName = "Shift Name already exists";
}
 }



// const isShiftNameExists = shiftData.some(
//   (item) =>
//     item.ShiftName?.trim().toLowerCase() ===
//     data.ShiftName?.trim().toLowerCase()
// );


const shortName = (data.ShortName || "").trim().toLowerCase();

 if (isBlank(data.ShortName)) {
  e.ShortName = "Short Name is required.";
} else if (shortName.length > 20) {
  e.ShortName = "Short Name cannot exceed 20 characters.";
} else if (!/^[A-Za-z\s]+$/.test(data.ShortName.trim())) {
  e.ShortName = "Short Name must contain alphabets and spaces.";
} else {
  const isShortExists = shiftData.some(
    (item) =>
      (item.ShortName || "").trim().toLowerCase() === shortName &&
      item.ShiftCode !== data.ShiftCode
  );

  if (isShortExists) {
    e.ShortName = "Short Name already exists.";
  }
}


  const shiftNo = String(data.ShiftNo ?? "").trim();


if (isBlank(data.ShiftNo)) {
  e.ShiftNo = "Shift No is required.";
} else if (!Number.isInteger(Number(data.ShiftNo))) {
  e.ShiftNo = "Shift No must be a whole number.";
} else if (Number(data.ShiftNo) <= 0) {
  e.ShiftNo = "Shift No must be greater than 0.";
} else {
  const isShiftNoExists = shiftData.some(
    (item) =>
      String(item.ShiftNo ?? "").trim() === shiftNo &&
      item.ShiftCode !== data.ShiftCode
  );

  if (isShiftNoExists) {
    e.ShiftNo = "Shift No already exists.";
  }
}


  // Timings
  if (isBlank(data.InTime)) e.InTime = "In Time is required.";
  if (isBlank(data.OutTime)) e.OutTime = "Out Time is required.";
  if (isBlank(data.BeginningIn)) e.BeginningIn = "Beginning In is required.";

  if (isBlank(data.BeginningOut)) e.BeginningOut = "Beginning Out is required.";

  if (isBlank(data.EndingIn)) e.EndingIn = "Ending In is required.";

  if (isBlank(data.EndingOut)) e.EndingOut = "Ending Out is required.";

  // Duration
  if (isBlank(data.WorkingMins)) {
    e.WorkingMins = "Working Minutes is required.";
  } else if (Number.isNaN(num(data.WorkingMins)) || num(data.WorkingMins) < 0) {
    e.WorkingMins = "Working Minutes cannot be negative.";
  }

  if (isBlank(data.WorkingHours)) {
    e.WorkingHours = "Working Hours is required.";
  } 
  // else if (
  //   Number.isNaN(num(data.WorkingHours)) ||
  //   num(data.WorkingHours) < 0
  // ) {
  //   e.WorkingHours = "Working Hours cannot be negative.";
  // }

  // Half Day Working Minutes: optional, but cannot exceed Working Minutes.
  if (isBlank(data.HalfDayWorkingMins)) {
    e.HalfDayWorkingMins = "Half Day Working Minutes is required.";
  } else if (
    Number.isNaN(num(data.HalfDayWorkingMins)) ||
    num(data.HalfDayWorkingMins) < 0
  ) {
    e.HalfDayWorkingMins = "Half Day Working Minutes cannot be negative.";
  } else if (
    !isBlank(data.WorkingMins) &&
    num(data.HalfDayWorkingMins) > num(data.WorkingMins)
  ) {
    e.HalfDayWorkingMins =
      "Half Day Working Minutes cannot exceed Working Minutes.";
  }

  // Half Day Working Hours: required and cannot exceed Working Hours.
  if (isBlank(data.HalfDayWorkingHours)) {
    e.HalfDayWorkingHours = "Half Day Working Hours is required.";
  }
  //  else if (
  //   Number.isNaN(num(data.HalfDayWorkingHours)) ||
  //   num(data.HalfDayWorkingHours) < 0
  // ) {
  //   e.HalfDayWorkingHours = "Half Day Working Hours cannot be negative.";
  // } 
  else if (
    !isBlank(data.WorkingHours) &&
    !isBlank(data.HalfDayWorkingHours) && 
    toMinutes(data.HalfDayWorkingHours) > 
    toMinutes(data.WorkingHours)
  )
   {
    e.HalfDayWorkingHours =
      "Half Day Working Hours cannot exceed Working Hours.";
  }

  // Lunch Break: optional, but cannot be negative when provided.
  // Lunch Break Minutes: required
  if (isBlank(data.LunchBreakMins)) {
    e.LunchBreakMins = "Lunch Break Minutes is required.";
  } else if (
    Number.isNaN(num(data.LunchBreakMins)) ||
    num(data.LunchBreakMins) < 0
  ) {
    e.LunchBreakMins = "Lunch Break Minutes cannot be negative.";
  } else if(
    !isBlank(data.WorkingMins) && num(data.LunchBreakMins) > getMinutesDifference(data.InTime, data.OutTime)
  )
  {
  e.LunchBreakMins =
    "Lunch Break Minutes cannot exceed Shift Duration.";
}


  // Lunch Break Hours: required
  // if (isBlank(data.LunchBreakHours)) {
  //   e.LunchBreakHours = "Lunch Break Hours is required.";
  // } 
  // else if (
  //   Number.isNaN(num(data.LunchBreakHours)) ||
  //   num(data.LunchBreakHours) < 0
  // ) {
  //   e.LunchBreakHours = "Lunch Break Hours cannot be negative.";
  // }



  const diff = getMinutesDifference(
  data.InTime,
  data.OutTime,

  // data.BeginningOutNextDay // or OutTimeNextDay if you have that checkbox
);

if (
  !isBlank(data.InTime) &&
  !isBlank(data.OutTime) &&
  diff <= 0
) {
  e.OutTime = "Out Time should be greater than In Time.";
}
if (diff > 16 * 60) {
  e.OutTime = "Shift duration cannot exceed 16 hours.";
}
if (
  beginningIn != null &&
  inTime != null &&
  beginningIn > inTime
) {
  e.BeginningIn = "Beginning In should be less or equal to In Time.";
}
if(
  inTime != null &&
  endingIn != null &&
   inTime > endingIn
){ 
  e.EndingIn = "Ending In should be greater than In Time"
}

if (
  endingIn != null &&
  beginningOut != null &&
  endingIn >= beginningOut
) {
  e.BeginningOut =
    "Beginning Out must be greater than Ending In.";
}
else if (
  beginningOut != null &&
  outTime != null &&
  beginningOut >= outTime
) {
  e.BeginningOut = "Beginning Out must be less than Out Time.";
}

if (
  outTime != null &&
  endingOut != null &&
  outTime > endingOut
) {
  e.EndingOut =
    "Ending Out must be greater or equal to Out Time.";
}
// if (
//   beginningIn != null &&
//   endingIn != null &&
//   beginningIn > endingIn
// ) {
//   e.BeginningIn =
//     "Beginning In must be less than or equal to Ending In.";
// }

// if(
//   beginningOut != null &&
// endingOut != null &&
// beginningOut > endingOut)
// {
//   e.BeginningOut = "Beginning Out must be less than or equal to Ending Out."
// }
// if (
//   data.BeginningOut &&
//   data.OutTime &&
//   toMinutes(data.BeginningOut) >= toMinutes(data.OutTime) || toMinutes(data.BeginningOut) <= toMinutes(data.BeginningIn)
// ) {
//   e.BeginningOut = "Beginning Out should be less than Out Time.";
// }
// if (
//   beginningOut != null &&
//   inTime != null &&
//   beginningOut <= inTime
// ) {
//   e.BeginningOut = "Beginning Out must be greater than In Time.";
// } else if (
//   beginningOut != null &&
//   beginningIn != null &&
//   beginningOut <= beginningIn
// ) {
//   e.BeginningOut = "Beginning Out must be greater than Beginning In.";
// } 


// if (
//   endingIn != null &&
//   inTime != null &&
//   endingIn < inTime
// ) {
//   e.EndingIn = "Ending In must be greater than or equal to In Time.";
// }

// if (
//   endingIn != null &&
//   outTime != null &&
//   endingIn >= outTime
// ) {
//   e.EndingIn = "Ending In must be before Out Time.";
// }
// if (
//   endingOut != null &&
//   endingIn != null &&
//   endingOut <= endingIn
// ) {
//   e.EndingOut =
//     "Ending Out must be after Ending In.";
// }

// if (
//   endingOut != null &&
//   outTime != null &&
//   endingOut <= outTime
// ) {
//   e.EndingOut =
//     "Ending Out must be after Out Time.";
// }

// if (data.EndingIn && data.EndingOut) {
//   const endingIn = getTime(
//     data.EndingIn,
//     data.EndingInNextDay
//   );

//   const endingOut = getTime(
//     data.EndingOut,
//     data.EndingOutNextDay
//   );

//   if (endingOut <= endingIn) {
//     e.EndingOut =
//       "Ending Out should be greater than Ending In.";
//   }
// }
  return e;
};

// Marks every validated field as touched so all errors surface on submit.
const TOUCH_ALL = {
  ShiftGroupCode: true,
  ShiftName: true,
  ShortName: true,
  ShiftNo: true,
  InTime: true,
  OutTime: true,
  BeginningIn: true,
  BeginningInNextDay: true,
  BeginningOut: true,
  BeginningOutNextDay: true,
  EndingIn: true,
  EndingOut: true,
  WorkingMins: true,
  WorkingHours: true,
  HalfDayWorkingMins: true,
  HalfDayWorkingHours: true,
  LunchBreakMins: true,
  LunchBreakHours: true,
};

function Shift() {

  const dispatch = useDispatch();
     const [loading, setLoading] = useState(false);

  const shiftData = useSelector(selectShiftData);
  const shiftMeta = useSelector(selectShiftMeta);
  const status = useSelector(selectShiftGroupStatus);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const shiftGroupData = useSelector(selectShiftGroupData);

  const [isEdit, setIsEdit] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [hasChildren, setHasChildren] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [changedFields, setChangedFields] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const showDurationMessage = () => {
  setShowMessage(true);

  setTimeout(() => {
    setShowMessage(false);
  }, 2000);
};

  // Server-side pagination + column filters
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [filters, setFilters] = useState({
    ShiftName: "",
    ShortName: "",
    ShiftNo: "",
    ShiftGroupName: "",
    InTime: "",
    OutTime: "",
    Status: "", // 0 = All, 1 = Active, 2 = Inactive
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  
const [highlightFields, setHighlightFields] = useState({});

const [showDurationUpdated, setShowDurationUpdated] = useState(false);


const highlightChangedFields = (fields) => {
  const active = {};

  fields.forEach((f) => {
    active[f] = true;
  });

  setHighlightFields(active);
};
const resetHighlights = () => {
  setHighlightFields({});
};

  // On submit: validate everything and reveal every field's error.
  const validateForm = () => {
    const newErrors = getShiftErrors(formData, shiftData);
    setErrors(newErrors);
    setTouched(TOUCH_ALL);
    return Object.keys(newErrors).length === 0;
  };

  // Re-run all rules against the latest form and mark `field` as touched so its
  // error can show. Cross-field rules (Half Day vs Working) stay in sync because
  // we always validate the whole form, not just the edited field.
  const runValidation = (next, field) => {
    setErrors(getShiftErrors(next, shiftData));
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  // Clears validation state when opening the modal fresh (Add / Edit).
  const resetValidation = () => {
    setErrors({});
    setTouched({});
  };

  // Adds the error class to an input once its field has been touched.
  const inputClass = (field) =>
    `se-input${touched[field] && errors[field] ? " se-input--error" : ""}`;

  // Renders the inline error message for a field once it has been touched.
  const fieldError = (field) =>
    touched[field] && errors[field] ? (
      <p className="error-text">{errors[field]}</p>
    ) : null;

  // Map the table's header filter inputs to API params; reset to page 1.
  // Each entry is { op, value } (text) or { value } (select).
  const handleHeaderFilterChange = useCallback((cf) => {
    setFilters({
      ShiftName: cf.shiftName?.value || "",
      ShortName: cf.shortName?.value || "",
      ShiftNo: cf.shiftNo?.value || "",
      ShiftGroupName: cf.shiftGroup?.value || "",
      InTime: cf.inTime?.value || "",
      OutTime: cf.outTime?.value || "",
      Status: cf.status?.value ?? "",
    });
    setCurrentPage(1);
  }, []);

  // Build request params: always paginate; include only the active filters.
  const buildParams = useCallback(() => {
    const params = { PageNumber: currentPage, PageSize: pageSize };
    if (filters.ShiftName.trim()) params.ShiftName = filters.ShiftName.trim();
    if (filters.ShortName.trim()) params.ShortName = filters.ShortName.trim();
    if (filters.ShiftNo.trim()) params.ShiftNo = filters.ShiftNo.trim();
    if (filters.ShiftGroupName.trim())
      params.ShiftGroupName = filters.ShiftGroupName.trim();
    if (filters.InTime.trim()) params.InTime = formatTime24(filters.InTime.trim());
    if (filters.OutTime.trim()) params.OutTime = formatTime24(filters.OutTime.trim());
    if (filters.Status !== "" && filters.Status !== "" && filters.Status !==null  && filters.Status !== undefined){ params.Status = filters.Status;
      }
    return params;
  }, [currentPage, pageSize, filters]);

  const formatTime = (time) => {
    if (!time) return null;

    if(time.split(":").length === 3){
      return time
  }
    return `${time}`; // HH:mm -> HH:mm:ss
  };

 
const formatDateTime = (time) => {
  if (!time) return null;

  return `${moment().format("YYYY-MM-DD")} ${time}:00`;
};
  
const convertTimeToHours = (value) => {
  if (!value) return "";

  const date = new Date(value);

  return (
    date.getUTCHours() +
    date.getUTCMinutes() / 60
  ).toFixed(2);
};

// const minutesToTime = (minutes) => {
//   if (minutes == null) return "";

//   const hrs = Math.floor(minutes / 60);
//   const mins = minutes % 60;

//   return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}:00`;
// };
const formatApiTime = (value) => {
  if (!value) return "";

  if (value.includes(" ")) {
    return value.split(" ")[1];
  }

  if (value.includes("T")) {
    return value.split("T")[1];
  }

  return value;
};
  // Debounced fetch: on mount and whenever page / size / filters change.
  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);

    try {
      await dispatch(shiftList(buildParams()));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const timer = setTimeout(fetchData, 400);

  return () => clearTimeout(timer);
}, [dispatch, buildParams]);

  const handleEdit = async (row) => {
    // console.log("Shift Data", shift)
    setIsEdit(true);
    // Fetch the full shift record by id, then pre-fill the edit modal.
    const result = await dispatch(getShiftById({ ShiftCode: row.id }));

    if (getShiftById.fulfilled.match(result)) {
      const shift = result.payload?.data?.data?.data;

      if (shift) {
        
        setFormData({
          ShiftCode: shift.ShiftCode ?? "",
          ShiftGroupCode: shift.ShiftGroupCode ?? "",
          ShiftGroupName: shift.ShiftGroupName ?? "",
          ShiftNo: shift.ShiftNo ?? "",
          ShiftName: shift.ShiftName ?? "",
          ShortName: shift.ShortName ?? "",
          BeginningIn: shift.BeginningIn ?? "",
          BeginningInNextDay: Boolean(shift.BeginningInNextDay),
          BeginningOut: shift.BeginningOut ?? "",
          BeginningOutNextDay: Boolean(shift.BeginningOutNextDay),
          InTime: shift.InTime ?? "",
          OutTime: shift.OutTime ?? "",
          EndingIn: shift.EndingIn ?? "",
          EndingInNextDay: Boolean(shift.EndingInNextDay),
          EndingOut: shift.EndingOut ?? "",
          EndingOutNextDay: Boolean(shift.EndingInNextDay),
          WorkingMins: shift.WorkingMins ?? "",
WorkingHours: formatTime(shift.WorkingHours),
          HalfDayWorkingMins: shift.HalfDayWorkingMins ?? "",
          HalfDayWorkingHours: formatTime(shift.HalfDayWorkingHours),
          LunchBreakMins: shift.LunchBreakMins ?? "",
          LunchBreakHours: formatTime(shift.LunchBreakHours),
          Status: Boolean(shift.Status),
        });
        resetValidation();
        resetHighlights();
        setShowModal(true);
      }
    }
  };

  const openDeletePopup = async (row) => {
    setSelectedRow(row);

    const result = await dispatch(
      checkDeleteShift({
        ShiftCode: row.id,
      }),
    );

    if (checkDeleteShift.fulfilled.match(result)) {
      setDeleteMessage(result.payload.data.message);
      setHasChildren(result.payload.data.hasChildren);
      setShowDeleteModal(true);
    }
  };

  const handleChange = (field, value) => {
  let next = {
    ...formData,
    [field]: value,
  };

  // Auto calculate duration
  if (field === "InTime" || field === "OutTime") {
    const duration = calculateDuration(
      field === "InTime" ? value : next.InTime,
      field === "OutTime" ? value : next.OutTime
    );
     console.log(duration);  

    if (duration) {
      next = {
        ...next,
        ...duration,
      };

      highlightChangedFields([
      "WorkingMins",
      "WorkingHours",
      "HalfDayWorkingMins",
      "HalfDayWorkingHours",
      // "LunchBreakHours",
    ]);

    showDurationMessage();

    // setTimeout(() => {
    //   setShowDurationUpdated(false);
    // }, 2500);
    }
  }

    if (field === "LunchBreakMins") {
    const totalMins = getMinutesDifference(next.InTime, next.OutTime);

    if (totalMins !== null) {
      const lunch = Number(value) || 0;
      const working = Math.max(totalMins - lunch, 0);

      next.WorkingMins = working;
next.WorkingHours = minutesToTime(working);
      next.HalfDayWorkingMins = Math.floor(working / 2);
     next.HalfDayWorkingHours = minutesToTime(
  Math.floor(working / 2)
);


     next.LunchBreakHours = minutesToTime(lunch);

     highlightChangedFields([
      "WorkingMins",
      "WorkingHours",
      "HalfDayWorkingMins",
      "HalfDayWorkingHours",
      "LunchBreakHours",
     ])
    }
  }

   console.log("WorkingHours:", next.WorkingHours);
  console.log("HalfDayWorkingHours:", next.HalfDayWorkingHours);
  console.log("LunchBreakHours:", next.LunchBreakHours);
  console.log("Full next object:", next);
  setFormData(next);
  runValidation(next, field);
};

  const handleUpdate = async () => {
   
    if (!validateForm()) return;
 setLoading(true)
    setSaving(true);

    const result = await dispatch(updateShift(formData));

    setSaving(false);

    if (updateShift.fulfilled.match(result)) {
      resetHighlights();
      setShowModal(false);
      dispatch(shiftList(buildParams()));
    }
    setLoading(false)
  };


  const handleSave = async () => {
    if (!validateForm()) return;

    setLoading(true)
    setSaving(true);

    const result = await dispatch(createShift(formData));

    setSaving(false);

    if (createShift.fulfilled.match(result)) {
      resetHighlights();
      setShowModal(false);

      dispatch(shiftList(buildParams()));
    }
    setLoading(false)
  };

  const handleDelete = async () => {
    setSaving(true);
setLoading(true)
    const result = await dispatch(
      deleteShift({
        ShiftCode: selectedRow.id,
        force: hasChildren,
      }),
    );

    setSaving(false);

    if (deleteShift.fulfilled.match(result)) {
      setShowDeleteModal(false);

      dispatch(shiftList(buildParams()));
    }
    setLoading(false)
  };

  const data = shiftData.map((item, index) => ({
    id: item.ShiftCode,

    sno: item.RowNum || (currentPage - 1) * pageSize + index + 1,

    shiftName: (item.ShiftName || "").toUpperCase(),

  shortName: (item.ShortName || "").toUpperCase(),

  shiftNo: item.ShiftNo,

  shiftGroup: (item.ShiftGroupName || "").toUpperCase(),

    inTime: formatTime12Hour(item.InTime),

    outTime: formatTime12Hour(item.OutTime),

    status: (
      <button
        className={
          item.Status
            ? "status-btn active-status"
            : "status-btn inactive-status"
        }
      >
        {item.Status ? "ACTIVE" : "INACTIVE"}
      </button>
    ),
  }));

  // Only block the whole page on the first load; keep the table during refetches.
  // if (status === "loading" && shiftData.length === 0) {
  //   return <Loader />;
  // }

  return (
<>
    {loading &&  <Loader isLoading={true}/>}
    <div className="shiftgroup-page">
      <PageHeader
        icon={<i className="bi bi-clock-history"></i>}
        title="Shift"
        subtitle="Manage shift timings, numbers and groups"
        actions={
          <>
            <button
              className="add-shift-btn"
              onClick={() => {
                dispatch(shiftGroupListsApis());
                setFormData(emptyForm);
                resetValidation();
                resetHighlights();
                setIsEdit(false);
                setShowModal(true);
              }}
            >
            + New
            </button>
          </>
        }
      />

      <div className="shift-data">
        <div className="table-container">
        <ReportTable
          columns={columns}
          data={data}
          serverSide={true}
          stickyColumns={["action"]}
          onHeaderFilterChange={handleHeaderFilterChange}

          renderActions={(row) => (
            <div className="shift-action-buttons">
              <button
                className="action-btn edit-btn"
                onClick={() => handleEdit(row)}
              >
                <i className="bi bi-pencil-square"></i>
              </button>

              <button
                className="action-btn delete-btn"
                onClick={() => openDeletePopup(row)}
              >
                <i className="bi bi-trash-fill"></i>
              </button>
            </div>
          )}
        />
        </div>

        <Pagination
          currentPage={currentPage}
          totalCount={shiftMeta?.totalRecords || 0}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={(size) => {
            setPageSize(size);
            setCurrentPage(1);
          }}
        />
      </div>
      

      {showModal && (
        <div className="se-overlay" onClick={() => setShowModal(false)}>
          <div className="se-modal" onClick={(e) => e.stopPropagation()}>
            <div className="se-modal__header">
              <div>
                <h3>{isEdit ? "Edit Shift" : " Add Shift"}</h3>
                <p className="se-modal__subtitle">
                  Update shift details and timings
                </p>
              </div>
              <button
                className="se-close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <div className="se-modal__body">
              <section className="se-section">
                <h4 className="se-section__title">Shift Details</h4>
                <div className="se-grid">
                  <div className="se-field se-field--full">
                    <label>Shift Group</label>
                    <SkSelect
                      size="md"
                      width="100%"
                      placeholder="Select Shift Group"
                      searchable={true}
                      invalid={!!(touched.ShiftGroupCode && errors.ShiftGroupCode)}
                      value={formData.ShiftGroupCode}
                      // options={shiftGroupData.map((group) => ({
                      //   value: group.ShiftGroupCode,
                      //   label: (group.ShiftGroupName || "").toUpperCase(),
                      // }))}

                      options={shiftGroupData.filter((group) => group.Status === true || group.Status === 1 ).map((group) => ({
                        value: group.ShiftGroupCode,
                        label: (group.ShiftGroupName || "").toUpperCase(),
                      }))
                    }

   
                    
                      onChange={(value) => {
                        const selected = shiftGroupData.find(
                          (item) => item.ShiftGroupCode === value,
                        );

                        const next = {
                          ...formData,
                          ShiftGroupCode: selected
                            ? selected.ShiftGroupCode
                            : "",
                          ShiftGroupName: selected
                            ? selected.ShiftGroupName
                            : "",
                        };
                        setFormData(next);
                        runValidation(next, "ShiftGroupCode");
                      }}
                    />
                    {fieldError("ShiftGroupCode")}
                  </div>

                  <div className="se-field">
                    <label>Shift Name</label>
                    <input
                      className={inputClass("ShiftName")}
                      type="text"
                      value={formData.ShiftName}
                      onChange={(e) =>
                        handleChange("ShiftName", e.target.value)
                      }
                    />
                    {fieldError("ShiftName")}
                  </div>

                  <div className="se-field">
                    <label>Short Name</label>
                    <input
                      className={inputClass("ShortName")}
                      type="text"
                      value={formData.ShortName}
                      onChange={(e) =>
                        handleChange("ShortName", e.target.value)
                      }
                    />
                    {fieldError("ShortName")}
                  </div>

                  <div className="se-field">
                    <label>Shift No</label>
                    <input
                      className={inputClass("ShiftNo")}
                      type="number"
                      value={formData.ShiftNo}
                      onChange={(e) => handleChange("ShiftNo", e.target.value)}
                    />
                    {fieldError("ShiftNo")}
                  </div>

                  <div className="se-field">
                    <label>Status</label>
                    <SkSelect
                      size="md"
                      width="100%"
                      value={formData.Status}
                      options={ACTIVE_STATUS_OPTIONS}
                      onChange={(value) => handleChange("Status", value)}
                      ariaLabel="Status"
                    />
                  </div>
                </div>
              </section>

              <section className="se-section">
                <h4 className="se-section__title">Timings</h4>
                <div className="se-grid">
                  <div className="se-field">
                    <label>In Time</label>
                    <input
                      className={inputClass("InTime")}
                      type="time"
                      value={formData.InTime}
                      onChange={(e) => handleChange("InTime", e.target.value)}
                    />
                    {fieldError("InTime")}
                  </div>

                  <div className="se-field">
                    <label>Out Time</label>
                    <input
                      className={inputClass("OutTime")}
                      type="time"
                      value={formData.OutTime}
                      onChange={(e) => handleChange("OutTime", e.target.value)}
                    />
                    {fieldError("OutTime")}

           {showMessage && (
  <div className={`duration-updated ${showMessage ? "show" : ""}`}>
    <i className="bi bi-check-circle-fill"></i>
    Duration updated automatically
  </div>
)}
                    
                  </div>

                  <div className="se-field">
                    <label>Beginning In</label>
                    <input
                      className="se-input"
                      type="time"
                      value={formData.BeginningIn}
                      onChange={(e) =>
                        handleChange("BeginningIn", e.target.value)
                      }
                    />
                    {fieldError("BeginningIn")}
                  </div>

                  <div className="se-field">
                    <label>Beginning In Next Day</label>

                    <input
                      type="checkbox"
                      checked={formData.BeginningInNextDay}
                      onChange={(e) =>
                        handleChange("BeginningInNextDay", e.target.checked)
                      }
                    />
                    {fieldError("BeginningInNextDay")}
                  </div>

                   <div className="se-field">
                    <label>Ending In</label>
                    <input
                      className="se-input"
                      type="time"
                      value={formData.EndingIn}
                      onChange={(e) => handleChange("EndingIn", e.target.value)}
                    />
                    {fieldError("EndingIn")}
                  </div>

                  <div className="se-field">
                    <label>Ending In Next Day</label>

                    <input
                      type="checkbox"
                      checked={formData.EndingInNextDay}
                      onChange={(e) =>
                        handleChange("EndingInNextDay", e.target.checked)
                      }
                    />
                    {fieldError("EndingInNextDay")}
                  </div>

                    <div className="se-field">
                    <label>Beginning Out</label>
                    <input
                      className="se-input"
                      type="time"
                      value={formData.BeginningOut}
                      onChange={(e) =>
                        handleChange("BeginningOut", e.target.value)
                      }
                    />
                    {fieldError("BeginningOut")}
                  </div>
                 
                  <div className="se-field">
                    <label>Beginning Out Next Day</label>

                    <input
                      type="checkbox"
                      checked={formData.BeginningOutNextDay}
                      onChange={(e) =>
                        handleChange("BeginningOutNextDay", e.target.checked)
                      }
                    />
                    {fieldError("BeginningOutNextDay")}
                  </div>
                  <div className="se-field">
                    <label>Ending Out</label>
                    <input
                      className="se-input"
                      type="time"
                      value={formData.EndingOut}
                      onChange={(e) =>
                        handleChange("EndingOut", e.target.value)
                      }
                    />
                                        {fieldError("EndingOut")}

                  </div>
                  <div className="se-field">
                    <label>Ending Out Next Day</label>

                    <input
                      type="checkbox"
                      checked={formData.EndingOutNextDay}
                      onChange={(e) =>
                        handleChange("EndingOutNextDay", e.target.checked)
                      }
                    />
                    {fieldError("EndingOutNextDay")}
                  </div>
                </div>
              </section>

              <section className="se-section">
                <h4 className="se-section__title">Duration</h4>
                <div className="se-grid">
                  <div className="se-field">
                    <label>Working Minutes</label>
                    <input
                     className={`
  ${inputClass("WorkingMins")}
  ${highlightFields.WorkingMins ? "field-highlight" : ""}
 
`}
                      type="number"
                      value={formData.WorkingMins}
                      readOnly
                      // onChange={(e) =>
                      //   handleChange("WorkingMins", e.target.value)
                      // }
                    />
                    {fieldError("WorkingMins")}
                  </div>
                  <div className="se-field">
                    <label>Working Hours</label>
                    <input
                     className={`
  ${inputClass("WorkingHours")}
  ${highlightFields.WorkingHours ? "field-highlight" : ""}

`}
                      type="text"
                      value={formData.WorkingHours}
                      readOnly
                     
                      // onChange={(e) =>
                      //   handleChange("WorkingHours", e.target.value)
                      // }
                    />
                    {fieldError("WorkingHours")}
                  </div>

                  <div className="se-field">
                    <label>Half Day Working Minutes</label>
                    <input
 className={`
  ${inputClass("HalfDayWorkingMins")}
  ${highlightFields.HalfDayWorkingMins ? "field-highlight" : ""}

`}
    
                      type="number"
                      value={formData.HalfDayWorkingMins}
                      readOnly
                     
                      // onChange={(e) =>
                      //   handleChange("HalfDayWorkingMins", e.target.value)
                      // }

                    />
                    {fieldError("HalfDayWorkingMins")}
                  </div>
                  <div className="se-field">
                    <label>Half Day Working Hours</label>
                    <input
                                                             className={`
  ${inputClass("HalfDayWorkingHours")}
  ${highlightFields.HalfDayWorkingHours ? "field-highlight" : ""}
  
`}
    
                      type="text"
                      value={formData.HalfDayWorkingHours}
                      readOnly
                     
                      // onChange={(e) =>
                      //   handleChange("HalfDayWorkingHours", e.target.value)
                      // }
                    />
                    {fieldError("HalfDayWorkingHours")}
                  </div>

                  <div className="se-field">
                    <label>Lunch Break Minutes</label>
                    <input
                      className={inputClass("LunchBreakMins")}
                      type="number"
                      value={formData.LunchBreakMins}
                      onChange={(e) =>
                        handleChange("LunchBreakMins", e.target.value)
                      }
                    />
                    {fieldError("LunchBreakMins")}
                  </div>
                  <div className="se-field">
                    <label>Lunch Break Hours</label>
                    <input
                        className={`${inputClass("LunchBreakHours")} ${
                        highlightFields.LunchBreakHours ? "field-highlight" : ""}`
                      }
                      type="text"
                      value={formData.LunchBreakHours}
                      readOnly
                      onChange={(e) =>
                        handleChange("LunchBreakHours", e.target.value)
                      }
                    />
                    {fieldError("LunchBreakHours")}
                  </div>
                </div>
              </section>
            </div>

            <div className="se-modal__footer">
              <button
                className="se-btn se-btn--ghost"
                onClick={() => setShowModal(false)}
                disabled={saving}
              >
                Cancel
              </button>
              <button
                className="se-btn se-btn--primary"
                onClick={isEdit ? handleUpdate : handleSave}
                disabled={saving}
              >
                {saving
                  ? isEdit
                    ? "Updating..."
                    : "Saving..."
                  : isEdit
                    ? "Update"
                    : "Save"}{" "}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="se-overlay">
          <div className="se-modal">
            <div className="se-modal__header">
              <h3>Delete Shift</h3>
            </div>

            <div className="se-modal__body">
              <p>{deleteMessage}</p>
            </div>

            <div className="se-modal__footer">
              <button
                className="se-btn se-btn--ghost"
                onClick={() => {
                  setShowDeleteModal(false);
                  setHasChildren(false);
                  setDeleteMessage("");
                }}
              >
                No
              </button>

              <button className="se-btn se-btn--primary" onClick={handleDelete}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default Shift;
